import { createSlice } from "@reduxjs/toolkit";

const initialState = {
 planId: "",
 planExpired: false,
};

const setCurrentPlan = (state, action) => {
  state.planId = action.payload
}

const setPlanExpired = (state, action) => {
    state.planExpired = action.payload
}
const getUserData = createSlice({
  name: "userData",
  initialState,
  reducers: {
   setUserJobPlan: setCurrentPlan,
   setPlanExpired: setPlanExpired,
  },
});

export default getUserData.reducer;